module.exports = __webpack_public_path__ + "media/images/background-team-520w-e7ddda34.jpg";